function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, forwardRef } from "react";
import { Table, Tag, Row, Col, Image, Alert } from "antd";
import Moment from "react-moment";
import { Container } from "react-bootstrap";
import { TelephoneInboundFill, EnvelopeAtFill } from "react-bootstrap-icons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var bill = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref2;

  var bill = _ref.bill;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      itemsAr = _useState2[0],
      setItemsAr = _useState2[1];

  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "D\xE9signation"
    }),
    dataIndex: "label",
    key: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, (_ref2 = {
    title: /*#__PURE__*/_jsx("b", {
      children: "P.Unitaire"
    }),
    dataIndex: "price"
  }, _defineProperty(_ref2, "dataIndex", "price"), _defineProperty(_ref2, "render", function render(price) {
    return /*#__PURE__*/_jsx("span", {
      children: price.toLocaleString("Fr")
    });
  }), _ref2), {
    title: /*#__PURE__*/_jsx("b", {
      children: "Mode"
    }),
    key: "mode",
    dataIndex: "mode",
    render: function render(t) {
      return /*#__PURE__*/_jsx("span", {
        children: t
      });
    }
  }, {
    title: /*#__PURE__*/_jsx("b", {
      children: "Montant"
    }),
    key: "amount",
    dataIndex: "amount",
    render: function render(t) {
      return /*#__PURE__*/_jsx("span", {
        children: t.toLocaleString("Fr")
      });
    }
  }];
  useEffect(function () {
    bill.bill_items.forEach(function (item) {
      setItemsAr(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: item.id,
          label: item.medical_item ? item.medical_item.label : "INTROUVABLE",
          mode: bill.company_id == null ? "ESPECE" : "PRISE EN CHARGE",
          price: item.medical_item ? item.medical_item.base_price : "INCONNU",
          quantity: item.quantity,
          amount: bill.company_id == null ? bill.patient_part : bill.company_part
        }]);
      });
    });
  }, []);
  return /*#__PURE__*/_jsxs(Container, {
    ref: ref,
    id: "printable",
    children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        span: 6,
        children: /*#__PURE__*/_jsx(Image, {
          preview: false,
          src: "/drawables/logo_sos.jpeg",
          width: "100%"
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 16,
        offset: 2,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            textAlign: "center"
          },
          children: [/*#__PURE__*/_jsx("h2", {
            children: /*#__PURE__*/_jsx("b", {
              children: "FACTURE"
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsxs("b", {
              children: [" ", /*#__PURE__*/_jsx(TelephoneInboundFill, {
                size: 24
              }), " (+224) 628 88 01 86 / 621 07 64 64 ", /*#__PURE__*/_jsx(EnvelopeAtFill, {
                size: 24
              }), " sosmedecinguinee@gmail.com"]
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        border: "4px solid #EE8742"
      }
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        span: 7,
        offset: 17,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            marginTop: "10px",
            fontSize: "20px"
          },
          children: ["Conakry, le ", /*#__PURE__*/_jsx(Moment, {
            date: bill.created_at,
            format: "DD/MM/YYYY"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      })
    }), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        span: 7,
        children: /*#__PURE__*/_jsxs("h5", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "FACTURE N\xB0: "
          }), "FCT-CL" + bill.id]
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 15,
        offset: 2,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            padding: "10px",
            background: "#2A4294",
            borderRadius: "8px"
          },
          children: /*#__PURE__*/_jsx("h3", {
            style: {
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsx("b", {
              style: {
                color: "#FFF"
              },
              children: bill.company_id == null ? bill.customer.firstname + " " + bill.customer.lastname : bill.company.label
            })
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        span: 24,
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Table, {
          dataSource: itemsAr,
          columns: cols,
          pagination: false,
          bordered: true
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h4", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "TOTAL :"
          }), " ", bill.total_amount.toLocaleString("Fr"), " GNF"]
        })]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        span: 24
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
      style: {
        border: "1px solid #9C9898",
        padding: "7px"
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          border: "4px solid #5B9BD5"
        }
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          span: 24,
          offset: 0,
          children: /*#__PURE__*/_jsx("b", {
            children: "Adresse : Commune de Kaloum, Manquepas - 4\xE8me Avenue N\xB0 Registre: RCCM/GC- KAL/071.677B/2016"
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          border: "4px solid #5B9BD5"
        }
      })]
    })]
  });
});
export default bill;